import { FC, useLayoutEffect } from 'react';
import * as am5 from '@amcharts/amcharts5';
import * as am5percent from '@amcharts/amcharts5/percent';
import * as am5plugins_exporting from "@amcharts/amcharts5/plugins/exporting";
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import './Charts.scss';

type PieChartColorsProps = {
    categoryName: string,
    color: am5.Color
};

type PieChartProps = {
    name: string,
    categoryFieldName: string,
    valueFieldName: string,
    data: any[],
    colors?: PieChartColorsProps[]
};

const PieChart: FC<PieChartProps> = ({ name, data, categoryFieldName, valueFieldName, colors }) => {
    useLayoutEffect(() => {
        am5.ready(function () {
            am5.addLicense('AM5M326788873');
            const root = am5.Root.new(`${name}-chart`);

            // If no colors specified 
            if (colors) {
                root.setThemes([am5themes_Animated.new(root)]);
            }
            else {
                // Set slice color from the following list
                const defaultTheme = am5.Theme.new(root);
                root.setThemes([am5themes_Animated.new(root), defaultTheme]);

                defaultTheme.rule("ColorSet").set("colors", [
                    am5.color(0x003b5c),
                    am5.color(0x035684),
                    am5.color(0x036eaa),
                    am5.color(0x0486cf),
                    am5.color(0x00293f),
                    am5.color(0x118ab2),
                    am5.color(0x253948),
                    am5.color(0x385870),
                    am5.color(0x487292),
                    am5.color(0x06d6a0),
                    am5.color(0x5686aa),
                    am5.color(0x073b4c),
                    am5.color(0x71afde),
                ]);
            }
            

            let chart = root.container.children.push(
                am5percent.PieChart.new(root, {})
            );


            am5plugins_exporting.Exporting.new(root, {
                menu: am5plugins_exporting.ExportingMenu.new(root, {}),
                dataSource: data,
                backgroundColor: am5.color(0xffffff),
                pdfOptions: {
                    disabled: true
                },
                jsonOptions: {
                    disabled: true
                },
                csvOptions: {
                    disabled: true
                },
                pdfdataOptions: {
                    disabled: true
                },
                htmlOptions: {
                    disabled: true
                },
                printOptions: {
                    disabled: true
                }
            });

            let series = chart.series.push(
                am5percent.PieSeries.new(root, {
                    name: "Series",
                    categoryField: categoryFieldName,
                    valueField: valueFieldName,
                })
            );

            series.slices.template.setAll({
                templateField: "sliceSettings"
            });

            // Set slices color 
            if (data && data.length > 0 && colors && colors.length > 0) {
                var tempData = data.map(a => Object.assign({}, a));
                tempData = tempData.map((value: any) => {
                    var colorSettings = colors.find(c => c.categoryName === value[categoryFieldName]);
                    if (colorSettings) {
                        value.sliceSettings = {
                            stroke: colorSettings.color,
                            fill: colorSettings.color,
                        }
                    }
                    return value;
                });

                series.data.setAll(tempData);
            }
            

        });
    }, []);// eslint-disable-line
    return <div id={`${name}-chart`} className="chart-container" />;
};

export default PieChart;
